import { AppIcon, AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppForms from "@toothfairy/shared-ui/AppForms";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { View, TouchableOpacity } from "react-native";
import useWorkspaces from "../../../../../Hooks/useWorkspaces";
import { useHistory } from "../../../../../Router";
import { isLargeScreen } from "../../../../MainViewContainer";

const QaHiringSecretLeaf = ({
  field,
  options,
  fetchOptions = () => {},
  type,
  isRecap = false,
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();
  const history = useHistory();
  const { getActiveWorkspace } = useWorkspaces();
  const [showHelp, setShowHelp] = useState(false);

  const filteredOptions =
    options?.filter((u) => u?.type == field?.subType) || [];
  const hasOptions = filteredOptions.length > 0;

  const getOAuthHelpContent = () => {
    if (field?.subType === "oauth") {
      return {
        title: t("settings.qa.oauthHelpTitle"),
        steps: [
          t("settings.qa.oauthStep1"),
          t("settings.qa.oauthStep2"),
          t("settings.qa.oauthStep3"),
          t("settings.qa.oauthStep4"),
          t("settings.qa.oauthStep5"),
        ],
        link:
          "https://docs.microsoft.com/en-us/azure/active-directory/develop/quickstart-register-app",
      };
    }
    return null;
  };

  const oauthHelp = getOAuthHelpContent();

  return isRecap ? (
    <View
      style={{
        marginLeft: 10,
        marginBottom: 15,
        padding: 12,
        backgroundColor: currentTheme?.theme?.backgroundColor,
        borderRadius: 8,
        borderLeftWidth: 3,
        borderLeftColor: currentTheme?.theme?.primary,
      }}
    >
      <AppText
        preventTranslation
        style={{
          fontWeight: "bold",
          fontSize: 13,
        }}
        color={currentTheme?.theme?.primary}
      >
        {field.label}
      </AppText>
      <AppText
        preventTranslation
        style={{
          fontSize: 11,
          marginTop: 4,
        }}
        color={currentTheme?.theme?.secondary_font_color}
      >
        Configured ✓
      </AppText>
    </View>
  ) : (
    <View
      style={{
        marginBottom: 25,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <AppForms.AppFormDropDown
          formFieldContainerStyle={{
            flex: 1,
          }}
          isElevated={false}
          dropDownStyle={{
            borderColor: currentTheme?.theme?.border_color,
            maxWidth: !isLargeScreen() && 250,
          }}
          showTextInputLabel
          label={field.label}
          isMandatory={field?.mandatory}
          name={field.name}
          values={field.options}
          items={[
            {
              label: t("settings.qa.selectAuthorisationType", { type: field.subType || "authorisation" }),
              value: null,
            },
            ...filteredOptions?.map((item) => {
              return {
                label: item?.name,
                value: item?.id,
              };
            }),
          ]}
        />
        <View
          style={{
            marginTop: 20,
            flexDirection: "row",
            display: "flex",
            gap: 10,
            marginLeft: 10,
          }}
        >
          <TouchableOpacity
            onPress={() => {
              window.open(
                `/workspaces/${getActiveWorkspace()?.id}/settings/${type}`,
                "_blank",
              );
            }}
            style={{
              padding: 6,
              borderRadius: 6,
              backgroundColor: currentTheme?.theme?.backgroundColor,
              borderWidth: 1,
              borderColor: currentTheme?.theme?.border_color,
            }}
          >
            <AppIcon
              icon={AppAssets?.icons?.add_icon}
              size={18}
              color={currentTheme?.theme?.primary}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => {
              fetchOptions();
            }}
            style={{
              padding: 6,
              borderRadius: 6,
              backgroundColor: currentTheme?.theme?.backgroundColor,
              borderWidth: 1,
              borderColor: currentTheme?.theme?.border_color,
            }}
          >
            <AppIcon
              icon={AppAssets?.icons?.reload}
              size={18}
              color={currentTheme?.theme?.secondary_font_color}
            />
          </TouchableOpacity>
        </View>
      </View>

      <View
        style={{
          marginLeft: 0,
          marginTop: 8,
          paddingHorizontal: 12,
          paddingVertical: 8,
          backgroundColor: hasOptions
            ? currentTheme?.theme?.backgroundColor
            : `${currentTheme?.theme?.orange}15`,
          borderRadius: 6,
          borderLeftWidth: 3,
          borderLeftColor: hasOptions
            ? currentTheme?.theme?.primary
            : currentTheme?.theme?.orange,
        }}
      >
        <AppText
          preventTranslation
          style={{
            fontSize: 12,
            lineHeight: 18,
          }}
          color={currentTheme?.theme?.secondary_font_color}
        >
          {field.description}
        </AppText>

        {!hasOptions && field?.mandatory && (
          <View
            style={{ flexDirection: "row", flexWrap: "wrap", marginTop: 6 }}
          >
            <AppText
              preventTranslation
              style={{
                fontSize: 11,
                fontWeight: "600",
              }}
              color={currentTheme?.theme?.orange}
            >
              ⚠️ No{" "}
            </AppText>
            <AppText
              preventTranslation
              style={{
                fontSize: 11,
                fontWeight: "600",
              }}
              color={currentTheme?.theme?.orange}
            >
              {field.subType || "authorisations"}
            </AppText>
            <AppText
              preventTranslation
              style={{
                fontSize: 11,
                fontWeight: "600",
              }}
              color={currentTheme?.theme?.orange}
            >
              {t("settings.qa.noAuthorisationsFound", { type: field.subType || "authorisations" })}
            </AppText>
          </View>
        )}

        {hasOptions && (
          <View
            style={{ flexDirection: "row", flexWrap: "wrap", marginTop: 4 }}
          >
            <AppText
              preventTranslation
              style={{
                fontSize: 11,
              }}
              color={currentTheme?.theme?.darkGrey}
            >
              💡{" "}
            </AppText>
            <AppText
              preventTranslation
              style={{
                fontSize: 11,
              }}
              color={currentTheme?.theme?.darkGrey}
            >
              {filteredOptions.length}{" "}
            </AppText>
            <AppText
              preventTranslation
              style={{
                fontSize: 11,
              }}
              color={currentTheme?.theme?.darkGrey}
            >
              {field.subType || t("settings.qa.authorisation")}
            </AppText>
            <AppText
              preventTranslation
              style={{
                fontSize: 11,
              }}
              color={currentTheme?.theme?.darkGrey}
            >
              {filteredOptions.length > 1 ? "s" : ""}{" "}
            </AppText>
            <AppText
              preventTranslation
              style={{
                fontSize: 11,
              }}
              color={currentTheme?.theme?.darkGrey}
            >
              {t("settings.qa.availableInWorkspace")}
            </AppText>
          </View>
        )}
      </View>

      {oauthHelp && !hasOptions && (
        <TouchableOpacity
          onPress={() => setShowHelp(!showHelp)}
          style={{
            marginTop: 10,
            marginLeft: 0,
            padding: 10,
            backgroundColor: `${currentTheme?.theme?.primary}10`,
            borderRadius: 6,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <AppText
              preventTranslation
              style={{
                fontSize: 12,
                fontWeight: "600",
              }}
              color={currentTheme?.theme?.white}
            >
              {t("settings.qa.needHelpWithOAuth")}
            </AppText>
            <AppIcon
              icon={
                showHelp
                  ? AppAssets?.icons?.arrow_right
                  : AppAssets?.icons?.arrow_down
              }
              size={14}
              color={currentTheme?.theme?.white}
            />
          </View>

          {showHelp && (
            <View style={{ marginTop: 10 }}>
              <AppText
                preventTranslation
                style={{
                  fontSize: 11,
                  fontWeight: "bold",
                  marginBottom: 6,
                }}
                color={currentTheme?.theme?.font_color}
              >
                {oauthHelp.title}
              </AppText>
              {oauthHelp.steps.map((step, index) => (
                <AppText
                  key={index}
                  preventTranslation
                  style={{
                    fontSize: 11,
                    marginLeft: 8,
                    marginBottom: 4,
                  }}
                  color={currentTheme?.theme?.secondary_font_color}
                >
                  {index + 1}. {step}
                </AppText>
              ))}
              <TouchableOpacity
                onPress={() => window.open(oauthHelp.link, "_blank")}
                style={{
                  marginTop: 8,
                  padding: 6,
                  backgroundColor: currentTheme?.theme?.primary,
                  borderRadius: 4,
                  alignSelf: "flex-start",
                }}
              >
                <AppText
                  preventTranslation
                  style={{
                    fontSize: 11,
                    color: currentTheme?.theme?.white,
                  }}
                >
                  {t("settings.qa.openAzureGuide")}
                </AppText>
              </TouchableOpacity>
            </View>
          )}
        </TouchableOpacity>
      )}

      <View
        style={{
          height: 1,
          backgroundColor: currentTheme?.theme?.mediumGrey,
          marginVertical: 15,
        }}
      />
    </View>
  );
};

export default QaHiringSecretLeaf;
